















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { UserController } from "@/services/request.service";
@Component
export default class PasswordModal extends Vue {
  @Prop({ default: false }) public visible!: boolean;
  @Prop() public type!: any;

  public passwordForm: any = {
    user: "",
    verificationCode: "",
    password: "",
    nextPassword: "",
  };
  public confirmLoading: boolean = false;
  public count: any = 60;
  public checkPassword: boolean = false;
  public get rules() {
    return {
      user: [
        {
          required: true,
          message: this.$t("login.emailError"),
          trigger: "blur",
          type: "email",
        },
      ],
      password: [
        {
          required: true,
          message: this.$t("login.passwordErr"),
          trigger: "blur",
        },
        { required: true, validator: this.validatePass, trigger: "blur" },
      ],
      nextPassword: [
        {
          required: true,
          message: this.$t("login.passwordErr"),
          trigger: "blur",
        },
        { required: true, validator: this.validatePass, trigger: "blur" },
      ],
      verificationCode: [
        {
          required: true,
          message: this.$t("login.verificationCodeTip"),
          trigger: "blur",
        },
      ],
    };
  }

  public validatePass: any = (rule, value, callback) => {
    if (!value) {
      callback(new Error(this.$tc("login.passwordErr")));
    } else {
      if (value.length < 8 || value.length > 20) {
        callback(new Error(this.$tc("login.passwordErr")));
      } else {
        callback();
      }
    }
  };

  public newPasswordChange() {
    if (this.passwordForm.nextPassword === this.passwordForm.password) {
      this.checkPassword = false;
    } else {
      this.checkPassword = true;
    }
  }
  @Watch("visible", { immediate: true })
  public clearModal() {
    if (this.visible === false) {
      this.passwordForm = {
        user: "",
        verificationCode: "",
        password: "",
        nextPassword: "",
      };
    }
  }
  public handleOk() {
    const passwordForm = this.$refs.passwordForm as any;
    passwordForm.validate((valid: any) => {
      if (valid) {
        if (
          this.passwordForm.nextPassword &&
          this.passwordForm.password &&
          this.passwordForm.nextPassword === this.passwordForm.password
        ) {
          const request: any = {
            email: this.passwordForm.user,
            vcode: this.passwordForm.verificationCode,
            newPassword: this.passwordForm.password,
            authPassword: this.passwordForm.nextPassword,
          };
          UserController.modifyPassword(request).then((res) => {
            this.$emit("cancel");
          });
        }
      }
    });

    // if (this.type === "new") {
    //   console.log(111);
    // }
    // if (this.type === "edit") {
    //   console.log(222);
    // }
  }
  public handleCancel() {
    this.$emit("cancel");
  }
  public sendVerifyCode() {
    if (this.type === "new") {
      const email = this.passwordForm.user;

      UserController.sendVerifyCode(email).then((res: any) => {
        console.log(res);
        let a = this.$refs.passwordForm as any;
        a.validateField("user", (err) => {
          if (!err && this.passwordForm.user) {
            const counter = setInterval(() => {
              if (this.count > 0) {
                this.count--;
              } else {
                this.count = 60;
                clearInterval(counter);
              }
            }, 1000);
          }
        });
      });
    }
    if (this.type === "edit") {
      UserController.vcodeSend().then((res: any) => {
        console.log(res);
      });
    }
  }
}
